<template>
  <div class="WhatsappSessionMobile widget-cotitrack">
    <template v-if="!logged">
      <div
        class="btn-al btn-al-md btn-al-azul-solid btn-cotizacion"
        title="Suscríbase"
        data-toggle="modal"
        data-target="#myModal2"
      >
        <div class="widget-cotitrack-icono"><i class="fa fa-user"></i></div>
        <div class="widget-cotitrack-texto">INICIA SESIÓN</div>
      </div>
    </template>
    <template v-else>
      <router-link
        to="/"
        class="btn-al btn-al-md btn-al-azul-solid btn-cotizacion"
        @click.native="loc_logout"
      >
        <div class="widget-cotitrack-icono"><i class="fa fa-lock"></i></div>
        <div class="widget-cotitrack-texto">CERRAR SESIÓN</div>
      </router-link>
    </template>
    <a
      href="https://api.whatsapp.com/send?phone=51998361469&text=Estimados!%20Necesito%20informaci%C3%B3n.%20&source=&data="
      target="_blank"
      class="btn-al btn-al-md btn-al-verde-solid btn-extranet"
      title="Whatsapp"
    >
      <div class="widget-cotitrack-icono"><i class="fa fa-whatsapp"></i></div>
      <div class="widget-cotitrack-texto">Whatsapp</div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'WhatsappSessionMobile',
  props: ['logged'],
};
</script>

<style lang="scss" src="./WhatsappSessionMobile.scss"></style>
